import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=0c3a54f6&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=0c3a54f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a54f6",
  null
  
)

export default component.exports